import React, { useState, useEffect, useCallback } from 'react';
import toast from 'react-hot-toast';
import apiClient from '../../utils/api';
import TogglePill from '../ui/TogglePill';

// "Finished logging for today? Tap what's done." One pill per domain. Marking a
// domain done is the attestation that lifts the day from presence-only to one
// whose manual data can sharpen guidance; tapping again reopens it for the
// after-dinner snack. The per-meal sub-items live on the Log page's checklist.

const todayStr = () => new Date().toISOString().split('T')[0];
const SHORT = { food: 'Food', exercise: 'Exercise', supplements: 'Supplements' };

const CompletenessCard = () => {
  const [status, setStatus] = useState(null);
  const [saving, setSaving] = useState(false);
  const day = todayStr();

  const load = useCallback(async () => {
    try {
      const res = await apiClient.get('/api/completeness', { params: { target_date: day } });
      setStatus(res.data);
    } catch {
      // Silent: the row just doesn't render if the fetch fails.
    }
  }, [day]);

  useEffect(() => { load(); }, [load]);

  const toggle = async (d) => {
    setSaving(true);
    try {
      const res = await apiClient.put('/api/completeness', {
        domain: d.domain, completed: !d.completed, items: d.items || [], date: day,
      });
      setStatus(res.data);
    } catch {
      toast.error('Could not save that just now');
    } finally {
      setSaving(false);
    }
  };

  if (!status) return null;

  return (
    <div className="grid gap-3 px-5 py-3.5 sm:grid-cols-[200px_1fr] sm:items-center sm:gap-4">
      <div className="text-[1.05rem] font-medium">
        Finished logging for today?
        <span className="block text-sm font-normal text-fg-3">Tap what’s done</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {status.domains.map((d) => (
          <TogglePill key={d.domain} on={d.completed} disabled={saving} onClick={() => toggle(d)}>
            {SHORT[d.domain] || d.label}
          </TogglePill>
        ))}
      </div>
    </div>
  );
};

export default CompletenessCard;
